import { css } from "@emotion/react";
import styled from "../../../../config/emotion";
import { roundCornersShadowBorder } from "../../../../assets/styles/styles";

export const FlowioTableWrapper = styled.div<{ hideBoxShadow?: boolean }>`
  ${(props) => !props.hideBoxShadow && roundCornersShadowBorder()}
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  background: white;
  font-size: 16px;
`;

export const FlowioTableOverflow = styled.div`
  min-width: 800px;
  overflow-x: auto;
  overflow-y: hidden;

  th:first-of-type,
  td:first-of-type {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    min-width: 0;
    width: auto;
    background: rgb(255, 255, 255);
    vertical-align: middle;

    input[type="checkbox"] {
      padding: 5px;
    }
  }

  th:first-of-type {
    input[type="checkbox"] {
      margin-top: 10px;
    }
  }

  th:last-child,
  td:last-child {
    position: -webkit-sticky;
    position: sticky;
    min-width: 0;
    right: 0;
    background: rgb(255, 255, 255);
  }

  th {
    text-align: center;
  }
`;

export const FlowioDivTableOverflow = styled.div`
  min-width: 800px;
  overflow-x: auto;
  overflow-y: hidden;

  .tableHeaderRow.stickyCol:first-of-type,
  .tableCol.stickyCol:first-of-type,
  .checkboxTh,
  .tableHeaderRow.stickyCol,
  .checkboxTd,
  .tableCol.stickyCol {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    min-width: 0;
    width: auto;
    background: rgb(255, 255, 255);
    vertical-align: middle;

    z-index: 10;

    input[type="checkbox"] {
      padding: 5px;
      width: 2rem;
      display: grid;
      place-items: center;
    }
  }

  .tableHeaderRow:first-of-type {
    input[type="checkbox"] {
      margin-top: 10px;
    }
  }

  .tableHeaderRow.stickyCol:last-of-type,
  .tableCol.stickyCol:last-of-type {
    position: -webkit-sticky;
    position: sticky;
    min-width: 0;
    right: 0;
    background: rgb(255, 255, 255);
    vertical-align: middle;
  }

  .tableHeaderRow {
    text-align: center;
  }
`;

export const FlowioTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  th,
  td {
    white-space: nowrap;
    margin: 0;
    padding: 0;
  }
`;

export const FlowioDivTable = styled.div`
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;

  .tableHeaderRow {
    white-space: nowrap;
    margin: 0;
    width: 100%;
  }
  .tableCol {
    white-space: nowrap;
    margin: 0;
    width: auto;
  }
`;

export const FlowioTableBody = styled.tbody`
  tr:last-child td {
    border-bottom: none;
  }
  td {
    padding: 5px;
    border-bottom: 1px solid #e7e8ec;
    textarea {
      padding: 5;
      margin: 0;
      width: 100%;
      height: 80%;
    }
  }
`;

export const FlowioDivTableBody = styled.div`
  display: table-row-group;
  width: 100%;
  .tableRow {
    display: table-row;
    height: 35px;
  }
  .tableRow:last-child .tableCol {
    border-bottom: none;
  }
  .tableCol,
  td {
    padding: 5px;
    border-bottom: 1px solid #e7e8ec;
    textarea {
      padding: 5;
      margin: 0;
      width: 100%;
      height: 80%;
    }
  }
`;

export const clickableTableRowCss = css`
  cursor: pointer;
  &:hover {
    background-color: #fbfbfb;
  }
`;

export const tableRowCss = css`
  display: table-row;
`;

export const tableCellCss = css`
  display: table-cell;
`;

export const noRowsMessageCss = css`
  width: 100%;
  background-color: #f1f1f1;
  text-align: center;
  font-size: 1.25em;
  color: #979797;
  margin-top: 12px;
`;
